export default "__VITE_ASSET__1b2343fa__"